<template>
  <div style="background: #FAF9F5;">
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="schools-posts-area" >
        <div class="row">
          <div class="col-lg-3 schools-posts-area-lf" style="padding-right: 0;">
              <div class="schools-posts-area-lf-t" style="font-size: 24px; line-height: 28px">
                International Partner Universities
              </div>
              <ul class="schools-posts-area-lf-m">
                    <li v-for="item in blogList" @click="checkLi(item.id)" :class="[currentBlog.id===item.id?'active':'']">{{item.title}}</li>

              </ul>
            <img class="schools-posts-area-lf-b" src="http://en.sc.ruc.edu.cn/static/images/school/png10.png" />
          </div>
          <div class="col-lg-9 post-list blog-post-list">
            <div class="single-post">



                <h2 class="blog-detail-tit">
                  {{ currentBlog.title }}
                </h2>


              <div class="blog-detail-img">
                <img style="max-height: 500px;" class="img-fluid wow slideInLeft" :src="currentBlog.img" alt="">
              </div>

              <div class="blog-detail-content content-wrap  wow slideInRight">
                <p v-html="currentBlog.content">
                </p>


              </div>



            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<script>
  export default {
    data () {
      return {
        currentBlog: {},
        blogList: [
          {
            id: '1',
            title: 'Sorbonne University',
            img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/jpg1.jpg',
            author: '中法学院',
            content: 'Founded in 1257, Sorbonne University is known as the “Mother of European Universities” and ranked second in the world in mathematics in US News ranking. It cooperates with Sino-French Institute to offer two majors, namely French and Mathematics & Applied Mathematics.'
          }, {
            id: '2',
            title: 'Paul-Valéry Montpellier 3 University',
            img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/jpg2.jpg',
            author: '智慧治理学院',
            content: 'Founded in 1289, Paul-Valéry Montpellier 3 University is one of the three oldest universities in France, and offers majors in national economic management, human resource management, and communication in cooperation with Sino-French Institute.'
          }, {
            id: '3',
            title: 'KEDGE Business School',
            img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/jpg3.jpg',
            author: '丝路学院',
            content: 'KEDGE Business School was established in 2013 by the merger of Euromed Marseille École de Management and Bordeaux École de Management. The former is the first higher business school in the history of France, and is ranked first among all business schools in France in terms of education at the undergraduate level. It offers a program in finance in cooperation with Sino-French Institute.'
          }
        ]
      }
    },
    created () {
      const id = this.$route.query.id
      this.currentBlog = this.getId(id)
      console.log(id, this.currentBlog)
    },
    methods: {
      getId (id) {
        return this.blogList.find(item => item.id === id)
      },
      checkLi (id) {
        this.currentBlog = this.getId(id)
      }
    }
  }
</script>

<style scoped lang="scss">
.blog-detail-tit:before{
  content: ' ';
  background-image: url(http://en.sc.ruc.edu.cn/static/images/titBg.png);

}

</style>



// WEBPACK FOOTER //
// universitiDetails.vue?e2f643b6